<template>
  <div class="address-wrap">
    <div @click="onClick">
      <normal-input
        v-model="addressStr"
        class="cc-form-input-wrap select-input"
        type="text"
        :readonly="true"
        placeholder="请输入地址"
      >
      </normal-input>
    </div>
    <popup-picker-multi-cols
      v-if="columns && columns.length"
      ref="picker"
      :levels="data.min_address + 1"
      :columns="columns"
      @confirm="onConfirm"
    ></popup-picker-multi-cols>
    <normal-input
      v-if="data.is_detail_address"
      v-model="data.address.detail"
      class="cc-form-input-wrap mt14"
      type="text"
      :maxlength="200"
      placeholder="请输入详细地址"
      @focus="focus"
      @change="$emit('change')"
    />
  </div>
</template>
<script>
import NormalInput from './NormalInput'
import { get } from 'lodash'
import PopupPickerMultiCols from './picker/PopupPickerMultiCols'
import { isAutoSaveFormEnabled } from '@/utils'

export default {
  name: 'AddressComp',
  components: {
    NormalInput,
    PopupPickerMultiCols
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    areaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [],
      addressStr: ''
    }
  },
  watch: {
    areaList(val) {
      this.columns = val
    }
  },
  mounted() {
    if (isAutoSaveFormEnabled()) {
      try {
        this.addressStr = this.getAddressStr()
      } catch (error) {
        console.log('初始化地址错误', error)
      }
    }
  },
  updated() {
    if (isAutoSaveFormEnabled()) {
      this.addressStr = this.getAddressStr() || this.addressStr
    }
  },
  methods: {
    getAddressStr() {
      const address = get(this.data, 'address') || {}
      let str = ''
      const provinceName = get(address, 'province.name')
      const cityName = get(address, 'city.name')
      const countyName = get(address, 'county.name')
      if (provinceName) {
        str = provinceName
        if (cityName) {
          str += `/${cityName}`
        }
        if (countyName) {
          str += `/${countyName}`
        }
      }
      return str
    },
    onConfirm({ names, ids }) {
      this.addressStr = names.join('/')
      this.data.address = {
        province: {
          name: names[0] || '',
          id: ids[0] || ''
        },
        city: {
          name: names[1] || '',
          id: ids[1] || ''
        },
        county: {
          name: names[2] || '',
          id: ids[2] || ''
        }
      }
      this.$emit('change')
    },
    onClick() {
      this.$refs.picker && this.$refs.picker.open()
      this.focus()
    },
    focus() {
      this.$emit('focus')
    }
  }
}
</script>
<style lang="less" scoped>
.address-wrap {
  width: 100%;
  .address-detail {
    margin-top: 10px;
  }
}
.select-input {
  padding-right: 30px;
}
.mt14 {
  margin-top: 14px !important;
}
</style>
